import { useCallback } from 'react';
import './InputField.scss';

type InputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
  onBlur?: () => void;
  component?: 'input' | 'textarea'
};

export const InputField = (props: InputProps) => {
  const {
    value,
    onChange,
    placeholder,
    className,
    disabled,
    size,
    onBlur,
    component = 'input',
  } = props;
  const sizeClass = size ? `size-${size}` : 'size-lg';

  const onValueChange = useCallback((event: { target: { value: string }; }) => {
    onChange(event.target.value);
  }, [onChange]);

  if (component === 'input') {
    return (
      <input
        value={value}
        onChange={onValueChange}
        placeholder={placeholder}
        className={`input-field ${className} ${sizeClass}`}
        disabled={disabled}
        onBlur={onBlur}
      />
    );
  }

  return (
    <textarea
      value={value}
      onChange={onValueChange}
      placeholder={placeholder}
      className={`textarea-field ${className} ${sizeClass}`}
      disabled={disabled}
      onBlur={onBlur}
    />
  );

};